import { render, staticRenderFns } from "./combineDetails.vue?vue&type=template&id=ea5bddc4&scoped=true&"
import script from "./combineDetails.vue?vue&type=script&lang=js&"
export * from "./combineDetails.vue?vue&type=script&lang=js&"
import style0 from "./combineDetails.vue?vue&type=style&index=0&id=ea5bddc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5bddc4",
  null
  
)

component.options.__file = "combineDetails.vue"
export default component.exports